export default {
  '请输入手机号/邮箱': '请输入手机号/邮箱',
  '请输入手机号/邮箱/子账号': '请输入手机号/邮箱/子账号',
  获取验证码: '获取验证码',
  请输入验证码: '请输入验证码!',
  请输入密码: '请输入密码!',
  '请设置密码（6-18位）': '请设置密码（6-18位）',
  '请输入密码（6-18位）': '请输入密码（6-18位）',
  请再次确认密码: '请再次确认密码',
  勾选表示您同意并愿意遵守云展动力平台以下协议政策: '勾选表示您同意并愿意遵守云展动力平台以下协议政策',
  我已有账户: '我已有账户',
  请阅读勾选协议: '请阅读勾选协议',
  请输入至少6个字符: '请输入至少6个字符',
  不能超过18位字符: '不能超过18位字符',
  请输入手机号码或邮箱: '请输入手机号码或邮箱',
  '请输入正确的手机号码或邮箱！': '请输入正确的手机号码或邮箱！',
  '密码强度不够,不能纯数字或者纯字母': '密码强度不够,不能纯数字或者纯字母',
  请再次输入密码: '请再次输入密码',
  两次密码不一致: '两次密码不一致',
  密码修改成功: '密码修改成功',
  验证码发送中: '验证码发送中...',
  '验证码发送成功,请注意查看': '验证码发送成功,请注意查看',
  强度: '强度',
  输入密码温馨提示: '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  云展动力平台服务协议: '《云展动力平台服务协议》',
  法律声明与隐私权政策: '《法律声明与隐私权政策》',
  版权政策与法律说明: '《版权政策与法律说明》',
  注册成功: '注册成功!',
  恭喜您成为了: '恭喜您,成为了',
  采购商: '采购商',
  参观采购商: '参观（采购）商',
  参观商可以免费在平台获取最新最热的全球展览:
    '参观商可以免费在平台获取最新最热的全球展览、行业头条、会展直播、企业3D、产品采购等服务,您也可以根据企业实际的定位,申请变更以下企业角色,获取更多精准大数据营销服务：',
  参与云上展览会议等: '参与云上展览、会议、视频直播、线上展示、匹配采购商',
  点击申请入驻: '点击申请入驻',
  发布展览会议视频直播: '发布展览、会议、视频直播、 照片直播、展馆电子图',
  为展览提供各种专业承包服务: '为展览提供各种专业承包服务',
  低: '低',
  中: '中',
  强: '强',
  该账号已注册: '该账号已注册',
  获取会员信息失败: '获取会员信息失败',
  欢迎您: '欢迎您',
  欢迎回来: '欢迎回来',
  早上好: '早上好',
  中午好: '中午好',
  晚上好: '晚上好',
}
